import { ReactNode } from 'react';
import { AvCheckbox, OpenSelect, RadioButton, Select } from '@fabric-ui/components';
import { Divider } from '@mui/material';
import { UseMutationOptions } from '@tanstack/react-query';
import { DocumentNode } from 'graphql/language';
import UploadFile from './UploadFile';

export const INPUT_TYPES = {
  TEXT: 'text',
  SELECT: Select,
  OPEN_SELECT: OpenSelect,
  BOOL: AvCheckbox,
  RADIO: RadioButton,
  UPLOAD_FILE: UploadFile,
  CUSTOM_COMPONENT: 'customComponent',
  DIVIDER: Divider,
};

export type FormComponent = {
  label?: string | React.ReactNode;
  valueName: string;
  required?: boolean;
  isRequired?: boolean;
  params?: any;
  type?: any;
  defaultValue?: any;
  shouldShow?: (data) => boolean;
  text?: ReactNode;
  sendAsArray?: boolean;
  shouldUpdateFieldWith?: (data) => { field: string; value: any };
  onChange?: (value: any) => void;
  changeEffect?: (value: any) => void;
};

export type Form = {
  title: string;
  description?: string;
  saveButtonProps?: { text?: string; disabled?: (...props) => boolean };
  formComponents: FormComponent[];
  query: DocumentNode | string;
  propagateTo?: string;
  handleResponse?: ResponseHandler;
  queryOptions?: Record<string, any>;
  onSuccessNext?: VoidFunction;
  onReset?: VoidFunction;
  customMutationFn?: (newData?: unknown) => Promise<unknown>;
  mutationOptions?: Omit<UseMutationOptions<unknown, unknown, unknown>, 'mutationFn'>;
};

export enum ResponseHandler {
  WORKFLOW = 'Workflow',
  ADD_ACCOUNT = 'addAccount',
  API_ACCESS = 'apiAccess',
  NONE = 'none',
  DEFAULT_MAPPING = 'defaultMapping',
}
